import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dialogOpenState: {
    logIn: false,
    register: false,
    newPassword: false,
    otp: false,
    resetPassword: false,
    createPost : false,
    deleteGroup: false,
    editPost : false,
    isLoginOtp: false,    
    loginOtpEmail: '', 
  },
};

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    setDialogState: (state, { payload }) => {
      state.dialogOpenState = payload;
    },
  },
});

export const { setDialogState } = dialogSlice.actions;
export default dialogSlice.reducer;
              


